import React from "react";
import SearchBox from "ReactComponents/Search/search-box";

export interface SearchModuleProps {
    SearchBoxText: string;
    Headline: string;
}

const SearchModule = (props: SearchModuleProps) => {
    return (
        <div className="content-module">
            <h2 className="content-header u-text-align-center">{props.Headline}</h2>
            <SearchBox SearchBoxText={props.SearchBoxText} />
        </div>
    );
};

export default SearchModule;
